import { ViewModel, View } from "binder";
import { ColumnFilter } from "../columnFilter";
import  { StringFilterView } from "./stringFilter-view"

export class StringFilterViewModel extends ColumnFilter{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new StringFilterView();
    }
    public getTypeId(): string {
        return "VM-3754F560-9830-4C13-A2D4-F02682C56AEE"
    }

    public set containsValue(v: string) { this._containsValue = v; } public get containsValue(): string { return this._containsValue;} private _containsValue: string;
    
}
